import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import getBrowserLangSetting from '@/middlewares/browserLangSettingFetcher'
import { messages } from '@/resources/lang/index'
// import localStorage from 'store'

Vue.use(VueI18n)

// localStorage に言語設定があればそれを、なければブラウザの言語を設定する
// ブラウザ言語に設定する場合には、あわせて localStorage.lang にも保存する
// TODO: すべての画面について多言語化対応が出来次第コメント削除
// const localStorageLang = localStorage.get('lang')
// const browserLangSetting = getBrowserLangSetting()
// const locale = localStorageLang || localStorage.set('lang', browserLangSetting)

export const i18n = new VueI18n({
  // locale: locale,
  locale: 'ja', // TODO: すべての画面について多言語化対応が出来るまでは日本語固定
  messages: messages, // resourceファイルをセット
})

// 以下 i18n の値を参照するための補助オブジェクトの作成用関数
const generatePathMap = (obj, basePath = '') => {
  return Object.keys(obj).reduce((result, key) => {
    const path = basePath === '' ? key : `${basePath}.${key}`
    if (typeof obj[key] === 'object') {
      result[key] = generatePathMap(obj[key], path)
    } else {
      result[key] = path
    }
    return result
  }, {})
}

export const i18nHints = generatePathMap(messages['ja'])
